module.exports = __webpack_public_path__ + "static/media/01_A5_102.64e59996.png";